import React, { useState } from 'react';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import {
    FilterComponentWrapper,
    FilterComponentHeaderFooter,
    TextBold,
    LineSeparator,
    FilterItemDiv,
    FilterAccountNameDiv,
    SearchBoxContainer,
} from './FilterAccounts.styled';
import FilterItemsCheckBox from './FilterItemsCheckBox';
import { anyAppliedOrCheckedFilter, logErrorToConsole } from 'src/utils/util';
import { Dot } from 'src/styles/CommonStyles.styled';
import FilterAccountLabel from 'src/common/components/filter/FilterAccountLabel';
import { useTranslation } from 'react-i18next';
import SearchBox from '../../refactoredComponents/searchbox/index';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const FilterAccounts = ({
    header,
    filters,
    onCheckBoxChange,
    isExpanded,
    updateExpandedViews,
    allFiltersWithStatus,
    reset = false,
    moreTemplateAccountFilter,
    updateSearch,
    searchProduct,
}) => {
    const [isAppliedFilter, setAppliedFilter] = useState(false);
    const { t } = useTranslation();
    useEffectWithErrorLogging(() => {
        setAppliedFilter(anyAppliedOrCheckedFilter(filters));
    }, [filters, isExpanded, allFiltersWithStatus, reset]);

   

    return (
        <FilterComponentWrapper
            className={
                filters?.filter((item) => item.name !== 'All').length > 0 || moreTemplateAccountFilter
                    ? ''
                    : 'disabled'
            }
        >
            <FilterComponentHeaderFooter
                onClick={() => {
                    try {
                        updateExpandedViews({
                            view: 'AccountView',
                            value: !isExpanded,
                        });
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
            >
                <TextBold color={'#140F4B'}>{header}</TextBold>
                <div>
                    {(() => {
                        if (isExpanded) {
                            return (
                                <>
                                    <img
                                        src={DownArrowFilter}
                                        style={{ transform: 'rotate(180deg)' }}
                                    ></img>
                                </>
                            );
                        } else {
                            return (
                                <>
                                    <div>
                                        {isAppliedFilter ? <Dot /> : ''}
                                        <img src={DownArrowFilter}></img>
                                    </div>
                                </>
                            );
                        }
                    })()}

                    {/* <img
                        src={isExpanded ? UpArrowFilter : DownArrowFilter}
                    ></img> */}
                </div>
            </FilterComponentHeaderFooter>

            {(() => {
                if (isExpanded) {
                    return (
                        <>
                            {moreTemplateAccountFilter ? (<SearchBoxContainer>
                                <SearchBox
                                    id="common-filter-filterAccounts-searchbox"
                                    margin={'auto 0px auto 0px'}
                                    updateSearch={updateSearch}
                                    placeholder={
                                        t('accounts.accountSearchBox.account_Name_Number.placeholder')
                                    }
                                    width={'100%'}
                                    height={'40px'}
                                    borderRadius={'20px'}
                                    paddingLeft={'2.2rem'}
                                    isSearchIcon={true}
                                    searchIconWidth={'min-content'}
                                    fontSize={'14px'}
                                    background={'none'}
                                    enterkeyhint={'go'}
                                    borderLeft={'none'}
                                    labelColor="#040404"
                                    fontWeight="400"
                                    fontFamily="AvenirNextWorld, Regular"
                                    padding={'0.5rem 2.2rem 0.6rem'}
                                    autoComplete="off"
                                    searchProduct={searchProduct}
                                    right={'8%'}
                                />
                            </SearchBoxContainer>) :  null}
                            {filters.length !== 0 && <LineSeparator />}

                            {filters.map((filter) => {
                                return (
                                    <FilterItemsCheckBox
                                        key={filter.accountId}
                                        filterItem={filter.name}
                                        filterItemId={filter.accountId}
                                        onCheckBoxChange={onCheckBoxChange}
                                        checkBoxName="accountFilters"
                                        isChecked={filter.isChecked}
                                        isFavourite={
                                            filter.isFavourite ||
                                            filter.isFavorite
                                        }
                                        singleLineDisplay={true}
                                        accountId={filter.accountId}
                                        lastElement={
                                            filters[filters.length - 1].name
                                        }
                                    >
                                        {filter.accountId ? (
                                            <FilterAccountLabel
                                                name={filter.name}
                                                accountId={filter.accountId}
                                                showFavourite={true}
                                                isFavourite={
                                                    filter?.isFavourite
                                                        ? filter.isFavourite
                                                        : filter?.isFavorite
                                                        ? filter.isFavorite
                                                        : false
                                                }
                                            />
                                        ) : (
                                            <FilterItemDiv>
                                                <FilterAccountNameDiv
                                                    maxWidth={'100%'}
                                                >
                                                    {filter.name === 'All'
                                                        ? t('common.allLabel')
                                                        : filter.name}
                                                </FilterAccountNameDiv>
                                            </FilterItemDiv>
                                        )}
                                    </FilterItemsCheckBox>
                                );
                            })}
                            {/* <br /> */}
                            {/* <br /> */}
                        </>
                    );
                } else {
                    return <></>;
                }
            })()}
        </FilterComponentWrapper>
    );
};

export default FilterAccounts;
